import { createSelector } from 'reselect';
import mappings from './mappings';

export const combinedColumnsSelector = createSelector(
    state => state.commodityReport.columnsForReportGrid,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getRows = state => state.commodityReport.commodityReportRows

export const getMonthlyUploadInitialised = state => state.commodityReport.initialisedMonthlyUpload;
export const getExportInitialised = state => state.commodityReport.initialisedExport;
export const getDailyFilesInitialised = state => state.commodityReport.initialisedDailyFiles;

export const getDefaultFilters = state => state.commodityReport.defaultFilters;

export const getFilterDefinitions = state => state.commodityReport.filterDefinitions;

export const getMonthlyUploadLastUpdated = state => state.commodityReport.lastUpdatedMonthly;
export const getExportLastUpdated = state => state.commodityReport.lastUpdatedExport;
export const getDailyFilesLastUpdated = state => state.commodityReport.lastUpdatedDailyFiles;
export const getDefaultSort = state => (
    state.commodityReport.gridSorting
);
export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};